import {ListUsersTariffPlans} from './list-users-tariff-plans';

export default ListUsersTariffPlans;
